module.exports = __webpack_public_path__ + "img/chicken-caesar-salad.30b9b065.jpg";